const attempt = (cost, price) => {
  const sanitized = Object.keys(cost).reduce((a, v) => ({ ...a, [v]: cost[v] < 0 ? cost[v] : -1 * cost[v] }), {});
  const result = {
    success: true,
    gain: { coins: price },
    cost: { ...sanitized }
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { resources } = context.party;
  const { gain, cost } = result;

  resources.delta({ ...gain, ...cost }, context);
};

// type can be 'food', 'water', 'ammo'
const adjustQuantityAndCost = (context, type) => {
  const { party, calendar } = context;
  // Allow buying specific quantities, priced per unit.
  const marketState = context.political.market(party, calendar).getMarketState();
  const pricePerUnit = marketState.prices[type];
  const maxQuantity = marketState.quantities['coins'] / pricePerUnit;

  return [maxQuantity, pricePerUnit];
};

export { adjustQuantityAndCost, attempt, executeSideEffects };
